import assetSubtypeAdvancedFilters from '../modals/createEditAssetSubtype/lan/en';
import deleteAssetSubtype from '../modals/deleteAssetSubtype/lan/en';

export default {
    ...assetSubtypeAdvancedFilters,
    ...deleteAssetSubtype,
}